module.exports = "/packs/media/images/icon-situation-d93baa67f7f799dd92e4d1b75f54420a.png";